// Route Configuration
const routes = [
  {
    path: '/',
    label: 'Home'
  },
  {
    path: '/artwork',
    label: 'Artwork'
  },
  {
    path: '/about',
    label: 'About'
  },
  {
    path: '/contact',
    label: 'Contact'
  }
];

export default routes;
